import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)
import userindex from '@/store/module/userindex'
export default new Vuex.Store({

  state: {

    //这里放全局参数

  },

  mutations: {

    //这里是set方法

  },

 getters: {     

 },

  actions: {
  },

  modules: {
    userindex
  }

})


// WEBPACK FOOTER //
// ./src/store/store.js